import { useState } from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import PayrollExportModal from 'modules/payroll_exporter/components/PayrollExportModal'

const ExportDataButton = () => {
  const {
    company: { id: companyId },
  } = useCurrentSession()
  const [exportModalOpen, setExportModalOpen] = useState<boolean>(false)

  const onCloseExports = () => {
    setExportModalOpen(false)
  }

  const handleExportButton = () => {
    setExportModalOpen(true)
    track(trackingEvents.payroll.userClicksExportData, {
      company_id: companyId,
    })
  }

  return (
    <>
      <Button type="secondary" onClick={handleExportButton} iconName="download">
        {i18n.t('payroll_bundle.export.export_title')}
      </Button>

      {exportModalOpen && <PayrollExportModal onClose={onCloseExports} />}
    </>
  )
}

export default ExportDataButton
